<template>
  <div class="loading-wrapper">
    <div class="animation-wrapper loaded">
      <div class="wordmark">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 189.5 52.2"
          style="enable-background:new 0 0 189.5 52.2;"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                class="st0"
                d="M12.759,33.05c-1.093,0.199-2.683,0.298-4.272,0.298c-4.57,0.099-7.153-3.179-7.153-8.147v-2.683
			c0-4.968,2.583-8.147,7.153-8.147c1.59,0,3.08,0.199,4.272,0.298c0.497,0.099,0.695,0.298,0.695,0.695v1.192
			c0,0.298-0.298,0.497-0.596,0.497h-0.099c-1.49,0-2.583,0-4.173,0c-2.683,0-4.272,1.788-4.272,5.564v2.683
			c0,3.775,1.49,5.564,4.272,5.564c1.689,0,2.683-0.099,4.173-0.199h0.099c0.298,0,0.596,0.199,0.596,0.497v1.192
			C13.454,32.752,13.256,32.951,12.759,33.05z"
              />
              <path
                class="st0"
                d="M27.364,33.249h-1.59c-0.298,0-0.695-0.298-0.695-0.695v-0.695c-1.59,0.894-3.279,1.689-5.166,1.689
			c-2.881,0-5.464-1.292-5.464-5.464v-0.397c0-3.676,2.086-5.464,8.147-5.464h2.484V20.83c0-2.782-0.994-3.775-3.577-3.775
			c-2.186,0-3.775,0.099-5.166,0.298h-0.199c-0.298,0-0.596-0.099-0.596-0.497v-1.192c0-0.298,0.199-0.596,0.695-0.596
			c1.391-0.199,2.881-0.497,5.166-0.497c4.67,0,6.557,2.384,6.557,6.359v11.724C28.059,32.851,27.761,33.249,27.364,33.249z
			 M25.079,24.208h-2.484c-4.073,0-5.166,0.894-5.166,3.279v0.497c0,2.384,1.192,3.08,3.08,3.08c1.59,0,2.881-0.497,4.57-1.391
			L25.079,24.208L25.079,24.208z"
              />
              <path
                class="st0"
                d="M38.193,17.054c-1.59,0-2.981,0.397-4.67,1.391v14.108c0,0.298-0.298,0.695-0.695,0.695h-1.689
			c-0.298,0-0.596-0.298-0.596-0.695V15.465c0-0.298,0.298-0.695,0.596-0.695h1.59c0.298,0,0.596,0.298,0.596,0.695v0.695
			c1.689-1.192,3.179-1.59,4.769-1.59c0.497,0,0.695,0.199,0.695,0.596v1.391C38.988,16.756,38.69,17.054,38.193,17.054z"
              />
              <path
                class="st0"
                d="M42.863,11.689h-1.689c-0.298,0-0.695-0.298-0.695-0.695V8.311c0-0.298,0.298-0.695,0.695-0.695h1.689
			c0.298,0,0.695,0.298,0.695,0.695v2.683C43.558,11.391,43.161,11.689,42.863,11.689z M42.764,33.249h-1.59
			c-0.298,0-0.695-0.298-0.695-0.695V15.365c0-0.298,0.298-0.695,0.695-0.695h1.59c0.298,0,0.695,0.298,0.695,0.695v17.188
			C43.459,32.851,43.161,33.249,42.764,33.249z"
              />
              <path
                class="st0"
                d="M53.295,33.448c-1.987,0-4.173-0.199-6.16-0.596c-0.596-0.099-0.695-0.298-0.695-0.795V8.51
			c0-0.298,0.199-0.596,0.596-0.596h1.689c0.298,0,0.596,0.298,0.596,0.596v6.259c1.292-0.199,2.881-0.298,3.974-0.298
			c4.868,0,7.352,2.981,7.352,8.246v2.285C60.647,30.169,58.362,33.448,53.295,33.448z M57.667,22.717
			c0-3.577-1.093-5.663-4.372-5.663c-0.994,0-2.782,0.099-3.974,0.199v13.413c1.192,0.099,2.782,0.199,3.974,0.199
			c3.279,0,4.372-2.086,4.372-5.762V22.717z"
              />
              <path
                class="st0"
                d="M76.345,24.903H65.019V25.4c0,3.974,1.59,5.464,4.67,5.464c1.987,0,4.471-0.099,6.061-0.298h0.199
			c0.298,0,0.497,0.099,0.497,0.497v1.192c0,0.497-0.099,0.695-0.695,0.795c-1.987,0.298-3.775,0.596-6.061,0.596
			c-3.875,0-7.65-1.788-7.65-8.048v-3.08c0-4.769,2.683-7.948,7.551-7.948c4.968,0,7.352,3.08,7.352,7.948v1.788
			C76.941,24.605,76.742,24.903,76.345,24.903z M73.861,22.32c0-3.775-1.391-5.266-4.372-5.266c-2.881,0-4.57,1.689-4.57,5.266
			v0.298h8.942V22.32z"
              />
            </g>
            <g>
              <path
                class="st1"
                d="M83.326,15.216l0.118,1.9c1.278-1.491,3.026-2.236,5.245-2.236c2.432,0,4.096,0.93,4.993,2.791
			c1.323-1.86,3.183-2.791,5.581-2.791c2.006,0,3.5,0.555,4.48,1.664s1.482,2.746,1.505,4.909v11.953h-4.085V21.571
			c0-1.154-0.252-2.001-0.757-2.539c-0.504-0.538-1.339-0.807-2.505-0.807c-0.93,0-1.69,0.249-2.278,0.748
			c-0.588,0.499-1,1.152-1.236,1.959l0.017,12.474H90.32v-11.97c-0.056-2.141-1.149-3.211-3.278-3.211
			c-1.636,0-2.796,0.667-3.48,2.001v13.18h-4.085v-18.19H83.326z"
              />
              <path
                class="st1"
                d="M115.974,33.742c-2.589,0-4.688-0.815-6.296-2.446c-1.608-1.631-2.412-3.802-2.412-6.514v-0.504
			c0-1.816,0.35-3.438,1.051-4.867s1.684-2.541,2.95-3.337c1.266-0.796,2.679-1.194,4.236-1.194c2.477,0,4.391,0.79,5.741,2.37
			s2.026,3.816,2.026,6.708v1.648h-11.886c0.123,1.502,0.625,2.69,1.505,3.564c0.88,0.874,1.987,1.311,3.32,1.311
			c1.872,0,3.396-0.757,4.573-2.27l2.202,2.101c-0.729,1.087-1.701,1.931-2.917,2.53C118.852,33.442,117.488,33.742,115.974,33.742z
			 M115.487,18.158c-1.121,0-2.026,0.392-2.715,1.177c-0.689,0.785-1.129,1.877-1.32,3.278h7.784V22.31
			c-0.09-1.367-0.454-2.401-1.093-3.102C117.504,18.508,116.619,18.158,115.487,18.158z"
              />
              <path
                class="st1"
                d="M130.642,10.795v4.421h3.211v3.026h-3.211v10.154c0,0.695,0.137,1.196,0.412,1.505
			c0.275,0.308,0.765,0.462,1.471,0.462c0.471,0,0.947-0.056,1.429-0.168v3.161c-0.93,0.258-1.827,0.387-2.69,0.387
			c-3.138,0-4.707-1.732-4.707-5.195V18.242h-2.992v-3.026h2.992v-4.421H130.642z"
              />
              <path
                class="st1"
                d="M145.454,18.948c-0.538-0.09-1.093-0.134-1.664-0.134c-1.872,0-3.133,0.717-3.783,2.152v12.44h-4.085v-18.19
			h3.9l0.101,2.034c0.986-1.58,2.354-2.37,4.102-2.37c0.583,0,1.065,0.078,1.446,0.235L145.454,18.948z"
              />
              <path
                class="st1"
                d="M151.38,33.406h-4.085v-18.19h4.085V33.406z"
              />
              <path
                class="st1"
                d="M161.466,30.481c1.02,0,1.866-0.297,2.539-0.891c0.672-0.594,1.031-1.328,1.076-2.202h3.85
			c-0.045,1.132-0.398,2.188-1.059,3.169c-0.661,0.981-1.558,1.757-2.69,2.328c-1.132,0.572-2.354,0.857-3.665,0.857
			c-2.544,0-4.562-0.824-6.052-2.471c-1.491-1.648-2.236-3.923-2.236-6.825v-0.42c0-2.768,0.74-4.985,2.219-6.649
			c1.479-1.664,3.497-2.497,6.052-2.497c2.163,0,3.925,0.63,5.287,1.891c1.362,1.261,2.076,2.917,2.143,4.968h-3.85
			c-0.045-1.042-0.401-1.9-1.068-2.572s-1.516-1.009-2.547-1.009c-1.322,0-2.342,0.479-3.06,1.437
			c-0.717,0.958-1.082,2.412-1.093,4.363v0.656c0,1.973,0.356,3.444,1.068,4.413S160.121,30.481,161.466,30.481z"
              />
              <path
                class="st1"
                d="M181.295,28.463c0-0.728-0.3-1.283-0.899-1.664s-1.594-0.717-2.984-1.009c-1.39-0.291-2.55-0.661-3.48-1.11
			c-2.04-0.986-3.06-2.415-3.06-4.287c0-1.569,0.661-2.88,1.984-3.934c1.322-1.054,3.004-1.58,5.043-1.58
			c2.174,0,3.931,0.538,5.27,1.614s2.009,2.471,2.009,4.186h-4.085c0-0.785-0.291-1.437-0.874-1.959
			c-0.583-0.521-1.356-0.782-2.32-0.782c-0.897,0-1.628,0.207-2.194,0.622c-0.566,0.415-0.849,0.969-0.849,1.664
			c0,0.628,0.263,1.115,0.79,1.463c0.527,0.347,1.591,0.698,3.194,1.051s2.861,0.773,3.774,1.261
			c0.913,0.488,1.591,1.073,2.034,1.757s0.664,1.513,0.664,2.488c0,1.636-0.678,2.962-2.034,3.976
			c-1.356,1.014-3.133,1.521-5.329,1.521c-1.491,0-2.819-0.269-3.984-0.807c-1.166-0.538-2.073-1.278-2.723-2.219
			c-0.65-0.941-0.975-1.956-0.975-3.043h3.967c0.056,0.964,0.42,1.706,1.093,2.228c0.672,0.521,1.563,0.782,2.673,0.782
			c1.076,0,1.894-0.205,2.454-0.614C181.014,29.66,181.295,29.125,181.295,28.463z"
              />
            </g>
          </g>
          <path
            class="st0 bolita"
            d="M147.043,10.492c0-0.628,0.199-1.149,0.597-1.563s0.967-0.622,1.706-0.622c0.74,0,1.311,0.207,1.715,0.622
	c0.403,0.415,0.605,0.936,0.605,1.563c0,0.616-0.202,1.129-0.605,1.538c-0.403,0.409-0.975,0.614-1.715,0.614
	c-0.74,0-1.308-0.205-1.706-0.614S147.043,11.108,147.043,10.492z"
          />
          <path
            class="st1 subtitle"
            d="M142.904,40.354c0,0.457-0.11,0.826-0.329,1.105c-0.221,0.281-0.522,0.421-0.907,0.421
	c-0.207,0-0.387-0.04-0.539-0.118c-0.152-0.08-0.279-0.196-0.381-0.351l-0.053,0.407h-0.498v-4.116l-0.478-0.082v-0.372h1.055v1.775
	c0.1-0.141,0.223-0.248,0.371-0.322c0.146-0.074,0.319-0.111,0.517-0.111c0.391,0,0.695,0.156,0.914,0.469s0.328,0.724,0.328,1.233
	V40.354z M142.324,40.292c0-0.365-0.066-0.662-0.199-0.891s-0.336-0.343-0.609-0.343c-0.178,0-0.328,0.043-0.45,0.129
	s-0.219,0.201-0.291,0.346v1.4c0.072,0.146,0.17,0.263,0.295,0.349c0.123,0.086,0.274,0.129,0.452,0.129
	c0.271,0,0.474-0.097,0.604-0.29c0.133-0.193,0.198-0.449,0.198-0.768V40.292z M146.458,39.021l-0.284,0.044l-1.207,3.24
	c-0.08,0.213-0.195,0.398-0.346,0.557s-0.353,0.237-0.606,0.237c-0.045,0-0.104-0.006-0.176-0.017s-0.128-0.021-0.167-0.03
	l0.059-0.454c-0.012-0.002,0.022,0,0.104,0.006s0.133,0.009,0.154,0.009c0.123,0,0.223-0.054,0.299-0.159
	c0.076-0.107,0.143-0.229,0.199-0.368l0.138-0.328l-1.046-2.689l-0.29-0.047v-0.372h1.28v0.372l-0.357,0.059l0.548,1.564
	l0.105,0.404h0.018l0.659-1.969l-0.36-0.059v-0.372h1.277V39.021z M151.597,38.862h-0.407l-0.108-0.604
	c-0.094-0.092-0.209-0.167-0.346-0.226s-0.3-0.088-0.489-0.088c-0.443,0-0.784,0.161-1.022,0.482s-0.357,0.729-0.357,1.223v0.067
	c0,0.494,0.116,0.903,0.35,1.226c0.233,0.324,0.558,0.485,0.972,0.485c0.193,0,0.369-0.03,0.527-0.091s0.28-0.135,0.366-0.223
	l0.108-0.604h0.407v0.759c-0.123,0.158-0.308,0.3-0.554,0.423c-0.246,0.125-0.531,0.187-0.855,0.187
	c-0.555,0-1.01-0.205-1.365-0.615s-0.533-0.926-0.533-1.547v-0.062c0-0.625,0.175-1.142,0.524-1.551s0.808-0.614,1.374-0.614
	c0.324,0,0.609,0.063,0.855,0.188c0.246,0.127,0.431,0.268,0.554,0.424V38.862z M154.28,41.818
	c-0.018-0.086-0.031-0.163-0.041-0.231s-0.017-0.137-0.021-0.205c-0.111,0.143-0.25,0.262-0.418,0.356
	c-0.166,0.094-0.345,0.142-0.534,0.142c-0.33,0-0.581-0.081-0.753-0.241c-0.172-0.162-0.258-0.389-0.258-0.682
	c0-0.301,0.121-0.532,0.365-0.695c0.242-0.163,0.576-0.245,1-0.245h0.595v-0.369c0-0.186-0.059-0.333-0.176-0.44
	c-0.117-0.109-0.28-0.163-0.489-0.163c-0.145,0-0.272,0.019-0.383,0.056s-0.199,0.088-0.268,0.152l-0.062,0.334h-0.445v-0.615
	c0.145-0.115,0.319-0.207,0.524-0.277c0.205-0.068,0.428-0.104,0.668-0.104c0.359,0,0.65,0.092,0.873,0.275s0.334,0.446,0.334,0.788
	v1.526c0,0.041,0,0.081,0.002,0.12c0,0.039,0.003,0.078,0.007,0.117l0.234,0.032v0.369H154.28z M153.352,41.396
	c0.191,0,0.366-0.046,0.524-0.138s0.271-0.202,0.34-0.331v-0.521h-0.615c-0.236,0-0.423,0.055-0.562,0.164
	c-0.137,0.109-0.206,0.242-0.206,0.398c0,0.139,0.043,0.244,0.129,0.318C153.048,41.359,153.178,41.396,153.352,41.396z
	 M155.517,39.021v-0.372h0.993l0.056,0.46c0.09-0.162,0.2-0.289,0.333-0.381c0.131-0.092,0.282-0.138,0.452-0.138
	c0.045,0,0.091,0.004,0.14,0.01c0.047,0.008,0.084,0.015,0.109,0.022l-0.076,0.536l-0.328-0.018c-0.152,0-0.28,0.036-0.384,0.107
	s-0.184,0.171-0.24,0.3v1.819l0.478,0.082v0.369h-1.532v-0.369l0.478-0.082v-2.265L155.517,39.021z M157.998,41.449l0.478-0.082
	v-2.265l-0.478-0.082v-0.372h1.055v2.719l0.478,0.082v0.369h-1.532V41.449z M159.053,37.837h-0.577v-0.589h0.577V37.837z
	 M162.87,40.354c0,0.457-0.11,0.826-0.329,1.105c-0.221,0.281-0.522,0.421-0.907,0.421c-0.207,0-0.387-0.04-0.539-0.118
	c-0.152-0.08-0.279-0.196-0.381-0.351l-0.053,0.407h-0.498v-4.116l-0.478-0.082v-0.372h1.055v1.775
	c0.1-0.141,0.223-0.248,0.371-0.322c0.146-0.074,0.319-0.111,0.517-0.111c0.391,0,0.695,0.156,0.914,0.469s0.328,0.724,0.328,1.233
	V40.354z M162.29,40.292c0-0.365-0.066-0.662-0.199-0.891s-0.336-0.343-0.609-0.343c-0.178,0-0.328,0.043-0.45,0.129
	s-0.219,0.201-0.291,0.346v1.4c0.072,0.146,0.17,0.263,0.295,0.349c0.123,0.086,0.274,0.129,0.452,0.129
	c0.271,0,0.474-0.097,0.604-0.29c0.133-0.193,0.198-0.449,0.198-0.768V40.292z M166.1,40.37v-0.36c0-0.43-0.11-0.78-0.33-1.03
	c-0.22-0.26-0.54-0.39-0.97-0.39c-0.36,0-0.68,0.15-0.95,0.45c-0.27,0.3-0.4,0.67-0.4,1.13v0.12c0,0.47,0.13,0.86,0.39,1.15
	c0.26,0.29,0.61,0.44,1.05,0.44c0.26,0,0.49-0.04,0.67-0.11c0.19-0.08,0.34-0.17,0.45-0.28l-0.22-0.37
	c-0.11,0.09-0.24,0.17-0.38,0.23c-0.15,0.05-0.32,0.08-0.52,0.08c-0.27,0-0.47-0.1-0.62-0.3c-0.15-0.19-0.23-0.44-0.23-0.75v-0.01
	H166.1z M164.06,39.9c0.03-0.24,0.11-0.45,0.25-0.61c0.14-0.16,0.3-0.25,0.49-0.25c0.24,0,0.42,0.08,0.54,0.23
	c0.12,0.15,0.18,0.34,0.18,0.57v0.08h-1.46V39.9z M172.277,38.402l-0.015-0.003l-1.38,3.419h-0.384l-1.38-3.416l-0.015,0.003
	l0.059,1.726v1.236l0.478,0.082v0.369h-1.532v-0.369l0.478-0.082v-3.36l-0.478-0.082v-0.372h0.478h0.738l1.359,3.466h0.018
	l1.356-3.466h1.219v0.372l-0.478,0.082v3.36l0.478,0.082v0.369h-1.532v-0.369l0.478-0.082v-1.236L172.277,38.402z M175.189,41.88
	c-0.441,0-0.792-0.146-1.054-0.44c-0.26-0.294-0.391-0.676-0.391-1.145v-0.129c0-0.451,0.134-0.826,0.402-1.127
	c0.269-0.299,0.587-0.449,0.954-0.449c0.426,0,0.749,0.129,0.968,0.387c0.221,0.258,0.33,0.602,0.33,1.031v0.36h-2.057l-0.009,0.015
	c0.006,0.305,0.083,0.555,0.231,0.752c0.148,0.195,0.356,0.294,0.624,0.294c0.195,0,0.366-0.028,0.515-0.083
	c0.146-0.057,0.274-0.133,0.382-0.23l0.226,0.375c-0.113,0.109-0.264,0.202-0.449,0.277C175.675,41.842,175.451,41.88,175.189,41.88
	z M175.102,39.044c-0.193,0-0.358,0.082-0.495,0.245s-0.221,0.367-0.252,0.613l0.006,0.015h1.462v-0.076
	c0-0.227-0.061-0.416-0.182-0.568S175.34,39.044,175.102,39.044z M179.104,41.44c-0.104,0.145-0.23,0.254-0.379,0.328
	c-0.15,0.074-0.323,0.111-0.521,0.111c-0.387,0-0.689-0.14-0.907-0.421c-0.218-0.279-0.326-0.648-0.326-1.105v-0.062
	c0-0.51,0.108-0.921,0.326-1.233s0.522-0.469,0.913-0.469c0.188,0,0.353,0.035,0.497,0.104c0.143,0.07,0.266,0.17,0.367,0.301
	v-1.292l-0.478-0.082v-0.372h0.478h0.577v4.119l0.478,0.082v0.369h-0.979L179.104,41.44z M177.548,40.354
	c0,0.318,0.065,0.574,0.196,0.768s0.333,0.29,0.606,0.29c0.172,0,0.316-0.039,0.434-0.117s0.214-0.188,0.29-0.331v-1.471
	c-0.074-0.133-0.171-0.238-0.29-0.316s-0.262-0.117-0.428-0.117c-0.275,0-0.479,0.114-0.61,0.343
	c-0.133,0.229-0.198,0.525-0.198,0.891V40.354z M180.568,41.449l0.478-0.082v-2.265l-0.478-0.082v-0.372h1.055v2.719l0.478,0.082
	v0.369h-1.532V41.449z M181.623,37.837h-0.577v-0.589h0.577V37.837z M184.608,41.818c-0.018-0.086-0.031-0.163-0.041-0.231
	s-0.017-0.137-0.021-0.205c-0.111,0.143-0.25,0.262-0.418,0.356c-0.166,0.094-0.345,0.142-0.534,0.142
	c-0.33,0-0.581-0.081-0.753-0.241c-0.172-0.162-0.258-0.389-0.258-0.682c0-0.301,0.121-0.532,0.365-0.695
	c0.242-0.163,0.576-0.245,1-0.245h0.595v-0.369c0-0.186-0.059-0.333-0.176-0.44c-0.117-0.109-0.28-0.163-0.489-0.163
	c-0.145,0-0.272,0.019-0.383,0.056s-0.199,0.088-0.268,0.152l-0.062,0.334h-0.445v-0.615c0.145-0.115,0.319-0.207,0.524-0.277
	c0.205-0.068,0.428-0.104,0.668-0.104c0.359,0,0.65,0.092,0.873,0.275s0.334,0.446,0.334,0.788v1.526c0,0.041,0,0.081,0.002,0.12
	c0,0.039,0.003,0.078,0.007,0.117l0.234,0.032v0.369H184.608z M183.68,41.396c0.191,0,0.366-0.046,0.524-0.138
	s0.271-0.202,0.34-0.331v-0.521h-0.615c-0.236,0-0.423,0.055-0.562,0.164c-0.137,0.109-0.206,0.242-0.206,0.398
	c0,0.139,0.043,0.244,0.129,0.318C183.376,41.359,183.506,41.396,183.68,41.396z"
          />
        </svg>
      </div>
      <div class="circles">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
import { SubscriberService } from "../services/subscriber.service";
export default {
  name: "loading",
  async created() {
    const roll = localStorage.getItem("roll");
    const subscriberId = localStorage.getItem("subscriberId");
    const businessUnitId = localStorage.getItem("businessUnitId");

    if (roll === "Administrator" || roll === "Consulting") {
      setTimeout(() => this.$router.push({ path: "/consulta" }), 4800);
    } else if (roll === "Customer") {
      const client = await new SubscriberService(this).getSubcriber(
        subscriberId
      );

      this.$store.commit("FillClient", client);
      const { comercialName, googleCustomerId } = client;
      setTimeout(
        () =>
          this.$router.push({
            path: `/cliente/${subscriberId}/businessUnit/${businessUnitId}/clientComercialName/${comercialName}/?customerId=${googleCustomerId}`
          }),
        2800
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.loading-wrapper {
  background-color: $blueish-gray-100;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.st0 {
  fill: #de6d27;
}
.st1 {
  fill: #2b4e69;
}
.st2 {
  fill: none;
}
.st3 {
  font-family: "RobotoSlab-Regular";
}
.st4 {
  font-size: 6px;
}

.animation-wrapper {
  align-self: center;
  max-width: 600px;
  position: relative;
  display: flex;
  flex-direction: column-reverse;
}

.wordmark {
  animation-duration: 3.8s;
  animation-name: wordmarkAnim;
  text-align: center;
  svg {
    width: 100%;
  }
  .subtitle {
    animation-duration: 4s;
    animation-name: wordmarkSubtitleAnim;
  }
}

.circles {
  animation-duration: 1s;
  animation-name: appearIn;
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  padding-left: 35px;

  span {
    width: 48px;
    height: 90px;
    opacity: 0.8;
    border-radius: 50%;
    display: block;
    border: 6px solid;
    position: absolute;
    &:first-child {
      border-color: #5db7d5;
    }
    &:nth-child(2) {
      border-color: #f28156;
    }
    &:nth-child(3) {
      border-color: #f05146;
    }
    &:nth-child(4) {
      border-color: #66c18d;
    }
  }
}

.bolita {
  animation-name: bolitaAnim;
  animation-duration: 4.5s;
  // animation: bolitaAnimInfinite 1.3s infinite;
  transform: scaleY(1);
  transform-origin: 20% 40%;
}

.animation-wrapper {
  &.loading {
    .circles {
      span {
        &:first-child {
          animation: blueCircleInfinite 2s linear infinite;
        }
        &:nth-child(2) {
          animation: orangeCircleInfinite 2.4s linear infinite;
        }
        &:nth-child(3) {
          animation: redCircleInfinite 2.8s linear infinite;
        }
        &:nth-child(4) {
          animation: greenCircleInfinite 3.2s linear infinite;
        }
      }
    }
  }
  &.loaded {
    .circles {
      span {
        &:first-child {
          animation-name: blueCircle;
          animation-duration: 3.3s;
          transform: rotate(-26deg);
        }
        &:nth-child(2) {
          animation-name: orangeCircle;
          animation-duration: 3.3s;
          transform: rotate(26deg);
        }
        &:nth-child(3) {
          animation-name: redCircle;
          animation-duration: 3.3s;
          transform: rotate(65deg);
        }
        &:nth-child(4) {
          animation-name: greenCircle;
          animation-duration: 3.3s;
          transform: rotate(-65deg);
        }
      }
    }
  }
}

@keyframes appearIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes blueCircleInfinite {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(-26deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes blueCircle {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-386deg);
  }
}

@keyframes orangeCircle {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(386deg);
  }
}

@keyframes orangeCircleInfinite {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(26deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes redCircle {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(425deg);
  }
}

@keyframes redCircleInfinite {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(65deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes greenCircle {
  0% {
    transform: rotate(0deg);
  }
  32% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-425deg);
  }
}

@keyframes greenCircleInfinite {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(-65deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes bolitaAnim {
  0% {
    transform: scaleY(1.8);
    opacity: 0;
  }
  85% {
    transform: scaleY(1.8);
    opacity: 0;
  }
  90% {
    transform: scaleY(0.8);
    opacity: 1;
  }
  100% {
    transform: scaleY(1);
    opacity: 1;
  }
}

@keyframes bolitaAnimInfinite {
  0% {
    transform: scaleY(0.8);
    opacity: 1;
  }

  50% {
    transform: scaleY(1.5);
    opacity: 1;
  }

  100% {
    transform: scaleY(0.8);
    opacity: 1;
  }
}

@keyframes wordmarkAnim {
  0% {
    margin-top: -100px;
    opacity: 0;
  }
  50% {
    margin-top: -100px;
  }
  60% {
    opacity: 0;
  }
  80% {
    margin-top: 0px;
    opacity: 1;
  }
}
@keyframes wordmarkSubtitleAnim {
  0% {
    transform: translateY(-12px);
    opacity: 0;
  }
  60% {
    transform: translateY(-12px);
  }
  70% {
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>
